import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Country } from 'App/i18n/enums';
import NexoSyncRoute from 'App/NexoSyncRoute';
import { useStoreInfo } from 'commons/hooks';
import NotFoundRoutes from './NotFoundRoutes';

const ArgentinaRoutes = lazy(() => import('./Argentina/ArgentinaRoutes'));
const BrazilRoutes = lazy(() => import('./Brazil/BrazilRoutes'));
const MexicoRoutes = lazy(() => import('./Mexico/MexicoRoutes'));

function Routes(): JSX.Element {
  const { storeInfo } = useStoreInfo();
  const mapRoutes = new Map();
  mapRoutes.set(
    Country.ARGENTINA,
    <Suspense fallback={null}>
      <ArgentinaRoutes />
    </Suspense>,
  );
  mapRoutes.set(
    Country.BRAZIL,
    <Suspense fallback={null}>
      <BrazilRoutes />
    </Suspense>,
  );
  mapRoutes.set(
    Country.MEXICO,
    <Suspense fallback={null}>
      <MexicoRoutes />
    </Suspense>,
  );

  function GetRoutesByCountry(key: string) {
    return mapRoutes.get(key) || <NotFoundRoutes />;
  }

  return (
    <Router>
      <NexoSyncRoute>{GetRoutesByCountry(storeInfo.country)}</NexoSyncRoute>
    </Router>
  );
}

export default Routes;
